import { gql } from "@apollo/client";

export const GET_DIGITAL_TWIN_DATA_BY_IDS_QUERY = gql`
  query DigitalTwinsByIds($ids: [ID!]!) {
    digitalTwinsByIds(ids: $ids) {
      _id
      tenant_id
      patient_id
      title
      date_of_creation
      date_of_oldest_file
      date_of_newest_file
      ct_instance_id
      mri_instance_id
      coronal_dx_instance_id
      sagittal_dx_instance_id
      front_morphology_picture
      back_morphology_picture
      right_morphology_picture
      left_morphology_picture
      pain_assessment
      clinical_history_id
      plans
      selected_plan
      custom_measurements
      radiodensity_measurements
      key_parameters
    }
  }
`;
